import {
  getActivityTypeColor,
  getActivityTypeLabel,
} from '@shared/helpers/design/activities.helpers';
import { getDisplayNumber } from '@shared/helpers/display/get-display-number.helper';
import type { ProgramGfaArea } from '@shared/models/design/activities/activity-type.model';

/** Colors and GFA shares shared by horizontal and vertical project bars; not program CO₂ results. */
export const getProjectProgramBarSegments = (
  programAreas: ProgramGfaArea[] = [],
  gfa: number,
  co2e: number,
) =>
  programAreas.map(({ type, area }) => ({
    key: type,
    value: gfa > 0 ? (co2e * area) / gfa : 0,
    color: getActivityTypeColor(type),
    tooltip: `${getActivityTypeLabel(type)} · ${getDisplayNumber(area)} m² · ${getDisplayNumber(gfa > 0 ? (area / gfa) * 100 : 0)}% GFA`,
  }));

/**
 * Preserve the previous GFA-scaled ring area around a shared center radius.
 * An empty organisation retains the area of the previous minimum 1 px ring.
 */
export const getProjectDonutRadii = (
  gfa: number,
  maxGfa: number,
  innerRadius: number,
  maxOuterRadius: number,
  centerRadius: number,
): { innerRadius: number; outerRadius: number } => {
  const minOuterRadius = innerRadius + 1;
  const fraction =
    maxGfa > 0 && Number.isFinite(maxGfa)
      ? Math.max(0, Math.min(1, gfa / maxGfa))
      : 0;
  const squaredRingArea =
    minOuterRadius ** 2 -
    innerRadius ** 2 +
    fraction * (maxOuterRadius ** 2 - minOuterRadius ** 2);
  const halfThickness = squaredRingArea / (4 * centerRadius);
  return {
    innerRadius: centerRadius - halfThickness,
    outerRadius: centerRadius + halfThickness,
  };
};
